import { useParams } from 'react-router';

import { useGetRunningTasksQuery } from '../../api/variantApi';
import {
  RUNNING_TASK_POLLING_INTERVAL,
  RUNNING_TASK_TYPES,
} from '../../running_tasks/constants';

/**
 * Returns true when a REFRESH_AND_RECALCULATE task is currently running for
 * the given variant (or the variant derived from the URL params when no
 * explicit id is passed).
 *
 * Analogous to the variant-lock check: while a refresh is running the user
 * should not be able to add or edit data on the variant, because the backend
 * recalculation would overwrite those changes.
 */
export const useHasRunningRefresh = (variantId?: string | number) => {
  const { vid: urlVariantId } = useParams<{ vid?: string }>();
  const effectiveVariantId = variantId ?? urlVariantId;

  const { data: runningTasks = [] } = useGetRunningTasksQuery(undefined, {
    pollingInterval: RUNNING_TASK_POLLING_INTERVAL,
  });

  return runningTasks.some(
    (task) =>
      task.variant_id != null &&
      String(task.variant_id) === String(effectiveVariantId) &&
      task.task_type === RUNNING_TASK_TYPES.REFRESH_AND_RECALCULATE &&
      task.status === 'running',
  );
};
